module.exports = __webpack_public_path__ + "static/img/cixiu1.464357df.png";